import { render } from "./sliderMobile.vue?vue&type=template&id=fb97c924"
import script from "./sliderMobile.vue?vue&type=script&lang=js"
export * from "./sliderMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__